const listeners = new Set();

const translationCache = {
    mergedBundle: {},
    setMergedBundle( bundle ) {
        this.mergedBundle = bundle || {};
        listeners.forEach( ( listener ) => listener( this.mergedBundle ) );
    },
    subscribe( listener ) {
        listeners.add( listener );
        return () => listeners.delete( listener );
    },
};

export default translationCache;